module.exports = __webpack_public_path__ + "img/openai.544d04b2.png";